import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "../i18n/en.json";
import translationTR from "../i18n/tr.json";
import translationAR from "../i18n/ar.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "ar", "tr"];

const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
  ar: {
    translation: translationAR,
  },
};
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    //lng: "en",
    resources,
    fallbackLng,
    supportedLngs: ["en", "ar", "tr"],

    detection: {
      checkWhitelist: true,
    },
    debug: false,

    whitelist: availableLanguages,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
